import { clsx } from 'clsx'
import { type HTMLProps, useState } from 'react'

type Props = HTMLProps<HTMLImageElement>
export const LazyImg = (props: Props) => {
  const [loaded, setLoaded] = useState<boolean>()

  return (
    <img
      {...props}
      alt={loaded ? props.alt : undefined}
      loading="lazy"
      onLoad={() => setLoaded(true)}
      onError={() => setLoaded(true)}
      className={clsx(
        props.className,
        !loaded &&
          'motion-safe:animate-pulse bg-gradient-to-r from-fv-gray-100 via-fv-gray-200 to-fv-gray-100',
      )}
    />
  )
}
